import { z } from 'zod';
import { CalendarDate, WorkflowCategory } from './project.js';
/**
 * Tra nhiều task theo id một lượt — APM-CD2-e, docs/plan-chilldoc-v2.md §5.
 *
 * Dòng checklist của `.chilldoc` gắn với task (`taskItem.taskId`): mở tài liệu là
 * hỏi trạng thái sống của mọi task đã gắn để đồng bộ dấu tick và vẽ chip. Một
 * tài liệu có thể gắn vài trăm dòng, nên trần là **200 id mỗi lượt** — web chia lô
 * khi nhiều hơn.
 */
export const MAX_TASK_LOOKUP_IDS = 200;
export const TaskLookupInput = z.object({
    ids: z.array(z.uuid()).max(MAX_TASK_LOOKUP_IDS),
});
export const TaskLookupItem = z.object({
    id: z.uuid(),
    projectId: z.uuid(),
    /** `{projectKey}-{number}` — nhãn ngắn trên chip. */
    key: z.string(),
    title: z.string(),
    statusId: z.uuid(),
    statusName: z.string(),
    category: WorkflowCategory,
    assigneeId: z.uuid().nullable(),
    assigneeName: z.string().nullable(),
    dueDate: CalendarDate.nullable(),
    /**
     * Cột đích khi **tick** / **bỏ tick** dòng: cột đầu tiên (theo vị trí) có
     * `category: 'done'` / `'todo'` **mà việc này được vào** — cột ngoài sprint
     * hoặc cột của chính sprint chứa nó (cùng luật với lệnh đổi trạng thái).
     * `null` = dự án không có cột như thế, dòng không tick được.
     */
    doneStatusId: z.uuid().nullable(),
    todoStatusId: z.uuid().nullable(),
    /** Ba trường cho hộp "chưa đủ thời gian tối thiểu" (`useCompleteTaskGuard`). */
    completableAt: z.iso.datetime().nullable(),
    actualStartAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
/**
 * Chỉ task người gọi **đọc được** (luật #5). Id không có trong `items` = đã xoá,
 * không tồn tại, hoặc người gọi không xem được — cố ý không phân biệt ba trường
 * hợp, như 404 của `GET tasks/:id`.
 */
export const TaskLookupResult = z.object({
    items: z.array(TaskLookupItem),
});
//# sourceMappingURL=task-lookup.js.map